(function () {
  if (window.__pcVideoToggleInit) return;
  window.__pcVideoToggleInit = true;

  var PLAYING_CLASS = 'product-card--video-playing';

  function findVideo(card) {
    return card.querySelector('.product-card__image--secondary video');
  }

  function getButton(card) {
    return card.querySelector('[data-video-toggle]');
  }

  function stop(card) {
    var video = findVideo(card);
    card.classList.remove(PLAYING_CLASS);
    var btn = getButton(card);
    if (btn) btn.setAttribute('aria-pressed', 'false');
    if (video) {
      try { video.pause(); video.currentTime = 0; } catch (_) {}
    }
  }

  function stopOthers(except) {
    var playing = document.querySelectorAll('.' + PLAYING_CLASS);
    for (var i = 0; i < playing.length; i++) {
      if (playing[i] !== except) stop(playing[i]);
    }
  }

  function play(card) {
    var video = findVideo(card);
    if (!video) return;
    stopOthers(card); // only one preview plays at a time
    card.classList.add(PLAYING_CLASS);
    var btn = getButton(card);
    if (btn) btn.setAttribute('aria-pressed', 'true');
    try { video.currentTime = 0; } catch (_) {}
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  function onClick(e) {
    var btn = e.target.closest && e.target.closest('[data-video-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var card = btn.closest('.product-card');
    if (!card) return;
    if (card.classList.contains(PLAYING_CLASS)) {
      stop(card);
    } else {
      play(card);
    }
  }

  document.addEventListener('click', onClick);

  // Pause any preview that scrolls fully out of view (saves battery/data).
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          var card = entry.target;
          if (card.classList.contains(PLAYING_CLASS)) stop(card);
        }
      });
    }, { threshold: 0 });

    function observeCards() {
      document.querySelectorAll('product-card').forEach(function (el) {
        var card = el.querySelector('.product-card') || el;
        if (card && !card.dataset.vtObserved) {
          card.dataset.vtObserved = '1';
          io.observe(card);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeCards);
    } else {
      observeCards();
    }

    var mo = new MutationObserver(observeCards);
    mo.observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('pagehide', function () { mo.disconnect(); });
  }
})();
